import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { showToast,ToastMessage } from '../../Shared/ToastMessage';
import { baseUrl } from '../../../api/common';

const PaymentStatusAdd = ({fetchPaymentStatusData,addPopupStatus, handleAddPopup, eventType, updateData}) => {

  const [updateId, setUpdateId] = useState("");

  const [formValues, setFormValues] = useState({
    payment_status_name:""
  });

  const [errors, setErrors] = useState({
    paymentStatusName:""
  });

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value });
  };

  const validate = () => {
    const newErrors = {
      paymentStatusName:""
    };  
    if (!formValues.payment_status_name.trim()) {
      newErrors.paymentStatusName = 'Payment status cannot be empty';
    }
    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === '');
  };  

  const clearInputValues = () => {
    setErrors({
      statusName:""
    });
    setFormValues({
      payment_status_name:""   
    });
    handleAddPopup(false);
  };  

  const addUpdatePaymentStatus = async () => {
    if (validate()) {
      console.log('Post Data:', formValues);   
      try {
        const requestData = {
          ...formValues,
          ...(eventType === "Update" && { id: updateId }),
        };
        console.log("Update requestData Data:", requestData);
        const response = await axios.post(
          `${baseUrl}/api/add_payment_status`,
          requestData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem('access_token'),
            },
          }
        );
        if (response.data.status) {
          showToast(response.data.message, 'success');
          fetchPaymentStatusData();
          clearInputValues();
        } else {
          showToast(response.data.message, 'error');
        }
      } catch (error) {
        console.error("Error during submission:", error);
        showToast("Submission failed. Please try again.", "error");
      }
    }
  };

  useEffect(() => {
    if (eventType === "Update" && updateData) {
      console.log("Update Data:", updateData);
      setUpdateId(updateData.id);
      setFormValues({
        payment_status_name: updateData.payment_status_name || '' 
      });
    }else{
      setErrors({
        statusName:""
      });
      setFormValues({
        payment_status_name:""   
      });
    }
  }, [eventType, updateData, addPopupStatus]);

  return (
    <>
    <ToastMessage/>    
    {addPopupStatus && (
      <div
        className={`extraspace_search_div search_div${addPopupStatus ? ' open' : ''}`}
      >
        <div className="card member_master_sidebar_scrool">
          <div className="member_edit_pop_flex mb-3 text-end">
            <h3>{eventType} Payment Status</h3>
            <div className="input-group-append">
              <span
                onClick={() => clearInputValues()}
                className="search_toggle btn btn-danger"
              >
                <i className="fa fa-times" />
              </span>
            </div>
          </div>
          <div className="table-responsive">
            <div className="body application_body_side">
              <div>             
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>Payment Status</label>
                        <input
                          type="text"
                          className={`form-control ${errors.paymentStatusName?"red_border":''}`}
                          value={formValues.payment_status_name}
                          onChange={(e) => handleInputChange('payment_status_name', e.target.value)} 
                          required
                        />
                        {errors && (                          
                          <p className="text-danger pos_abos">{errors.paymentStatusName}</p>                          
                        )}
                      </div>
                    </div>
                    <div className="col-md-12 member_button_flex">
                      <button onClick={() => addUpdatePaymentStatus()} className="btn btn-outline-info">
                      {eventType}
                      </button>
                      <a
                        onClick={() => clearInputValues()}
                        className="btn btn-outline-danger"
                      >
                        Close
                      </a>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
    </>
  );
};

export default PaymentStatusAdd;
